export default __webpack_public_path__ + "static/media/Laboratory 02.e1cd16f8.jpg";